import httpClientGalleries from '../api/httpClientGalleries';

const base = '/api/galleries/AllGallery';

export const getAll = async ({ pageNumber = 1, pageSize = 10, showInGalleryPool, relatedEntityType } = {}) => {
  const params = { pageNumber, pageSize };
  if (showInGalleryPool !== undefined && showInGalleryPool !== null) {
    params.showInGalleryPool = showInGalleryPool;
  }
  if (relatedEntityType !== undefined && relatedEntityType !== null) {
    params.relatedEntityType = relatedEntityType;
  }
  const response = await httpClientGalleries.get(`${base}/GetAll`, { params });
  return response.data;
};

export const getByRelatedEntityNews = async (newsMongoId) => {
  const response = await httpClientGalleries.get(`${base}/GetByRelatedEntityNews/${newsMongoId}`);
  return response.data;
};

export const create = async (payload) => {
  const response = await httpClientGalleries.post(`${base}/Create`, payload);
  return response.data;
};

export const update = async (payload) => {
  const response = await httpClientGalleries.put(`${base}/Update`, payload);
  return response.data;
};

export const remove = async (id) => {
  const response = await httpClientGalleries.delete(`${base}/Delete/${id}`);
  return response.data;
};

export const getById = async (id) => {
  const response = await httpClientGalleries.get(`${base}/GetById/${id}`);
  return response.data;
};

export const getByType = async (relatedEntityType) => {
  const response = await httpClientGalleries.get(`${base}/GetByType/${relatedEntityType}`);
  return response.data;
};

export const getByRelatedEntity = async (relatedEntityType, relatedEntityId) => {
  const response = await httpClientGalleries.get(`${base}/GetByRelatedEntity/${relatedEntityType}/${relatedEntityId}`);
  return response.data;
};

export const addImages = async (galleryId, files, altText = null) => {
  const formData = new FormData();
  (files || []).forEach((file) => {
    if (file instanceof File) formData.append('files', file, file.name);
  });
  if (altText) formData.append('altText', altText);

  const response = await httpClientGalleries.post(`${base}/AddImages/${galleryId}/Images`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const removeImage = async (galleryId, imageId) => {
  const response = await httpClientGalleries.delete(`${base}/RemoveImage/${galleryId}/Images/${imageId}`);
  return response.data;
};

export const reorderImages = async (galleryId, imageIdsInOrder) => {
  const response = await httpClientGalleries.put(`${base}/ReorderImages/${galleryId}/Images/Reorder`, imageIdsInOrder);
  return response.data;
};

export const reorderGalleries = async ({ galleryIdsInOrder }) => {
  const response = await httpClientGalleries.put(`${base}/Reorder`, {
    galleryIdsInOrder,
  });
  return response.data;
};

export default {
  getAll,
  getByRelatedEntityNews,
  create,
  update,
  remove,
  getById,
  getByType,
  getByRelatedEntity,
  addImages,
  removeImage,
  reorderImages,
  reorderGalleries,
};

